
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { fetchAllUsers, exportUsersToExcel,updateUserAccessLevel, fetchAccessLevels,fetchNewUserAccessList, addNewUserAccess, deleteNewUserAccess } from '../../services/api';
import toast from 'react-hot-toast';
import {IoClose, IoSaveOutline, IoPersonAddOutline, IoTrashOutline } from 'react-icons/io5';
import {
    IoShieldCheckmark,
    IoMail,
    IoChevronBack,
    IoChevronForward,
    IoSearchOutline,
    IoDownloadOutline,
    IoArrowUp,
    IoArrowDown,
    IoSettingsOutline, IoWalletOutline, IoPeopleOutline // Added new icon
} from 'react-icons/io5';
import { VscChromeClose } from "react-icons/vsc";
import { TokenUsageModal } from './TokenUsageModal';
import { CostSettingsModal } from './CostSettingsModal';
import McpOriginsManager from '../../components/McpConnections/McpManagement/McpOriginsManager';
import PreApprovedUserModal from './PreApprovedUserModal';


/**
 * Pagination Component
 * Renders the pagination controls.
 */
const Pagination = ({ currentPage, totalPages, onPageChange, totalUsers, limit }) => {
    if (totalPages <= 1) return null;

    const startItem = (currentPage - 1) * limit + 1;
    const endItem = Math.min(currentPage * limit, totalUsers);

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between mt-6 text-s-text">
            <p className="text-sm mb-4 sm:mb-0">
                Showing <span className="font-semibold text-p-text">{startItem}</span> to <span className="font-semibold text-p-text">{endItem}</span> of <span className="font-semibold text-p-text">{totalUsers}</span> results
            </p>
            <div className="flex items-center space-x-2">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="p-2 rounded-lg hover:bg-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                    <IoChevronBack className="h-5 w-5" />
                </button>
                <span className="text-sm font-medium text-p-text">
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="p-2 rounded-lg hover:bg-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                    <IoChevronForward className="h-5 w-5" />
                </button>
            </div>
        </div>
    );
};

export default Pagination;